// extracted by mini-css-extract-plugin
export var autoExpand = "_2c-b";
export var container = "_2c-a";
export var containerWidth = "_2c-8";
export var disabled = "_2c-2";
export var error = "_2c-3";
export var fullWidth = "_2c-9";
export var highlightContainer = "_2c-5";
export var inputWrapper = "_2c-0";
export var small = "_2c-1";
export var textarea = "_2c-4";
export var validatedTextarea = "_2c-6";
export var visuallyHidden = "_2c-7";